// File: src/components/KYC.js
import React, { useState, useRef } from "react";
import "../../Styles/KYC.css";
import { showSuccess } from "../../utils/Toast";

export default function KYC({ onBack }) {
  const cards = [
    { id: "shop", title: "Shop and Establishment Proof" },
    { id: "gst", title: "GST Number" },
    { id: "drug", title: "Drug License" },
    {
      id: "mci",
      title: "MCI",
      subtitle: "Medical Council of UAE Registration",
    },
    {
      id: "vci",
      title: "VCI",
      subtitle: "Veterinary Council of UAE Registration",
    },
    {
      id: "dci",
      title: "DCI",
      subtitle: "Dental Council of UAE Registration",
    },
    {
      id: "med_staff",
      title:
        "I'm a medical staff/student buying for educational/professional use",
      subtitle: "You can buy limited products",
    },
    { id: "patient", title: "I'm a patient buying for personal use" },
  ];

  const [selectedCard, setSelectedCard] = useState(null);
  const [agree, setAgree] = useState(false);
  const [gstNumber, setGstNumber] = useState("");
  const [shopName, setShopName] = useState("");
  const [proofNumber, setProofNumber] = useState("");
  const [drugNumber, setDrugNumber] = useState("");
  const [fileInfo, setFileInfo] = useState(null);
  const fileInputRef = useRef(null);
  const cameraInputRef = useRef(null);
  const [doctorName, setDoctorName] = useState("");
  const [mciNumber, setMciNumber] = useState("");
  const [doctorNameVci, setDoctorNameVci] = useState("");
  const [vciNumber, setVciNumber] = useState("");
  const [doctorNameDci, setDoctorNameDci] = useState("");
  const [dciNumber, setDciNumber] = useState("");
  const [medName, setMedName] = useState("");
  const [medIdNumber, setMedIdNumber] = useState("");

  const isGstValid = gstNumber.trim().length > 0 && agree;
  const isDrugFormValid = () => {
    return (
      shopName.trim().length > 0 &&
      drugNumber.trim().length > 0 &&
      fileInfo !== null &&
      agree === true
    );
  };

  const isMciValid = () => {
    return (
      doctorName.trim().length > 0 &&
      mciNumber.trim().length > 0 &&
      fileInfo !== null &&
      agree === true
    );
  };

  const isVciValid = () => {
    return (
      doctorNameVci.trim().length > 0 &&
      vciNumber.trim().length > 0 &&
      fileInfo !== null &&
      agree === true
    );
  };

  const isDciValid = () => {
    return (
      doctorNameDci.trim().length > 0 &&
      dciNumber.trim().length > 0 &&
      fileInfo !== null &&
      agree === true
    );
  };

  const isMedStaffValid = () => {
    return (
      medName.trim().length > 0 &&
      medIdNumber.trim().length > 0 &&
      fileInfo !== null &&
      agree === true
    );
  };

  const handleMedStaffSubmit = (e) => {
    e.preventDefault();
    if (!isMedStaffValid()) return;
    showSuccess("Medical Student/Employee ID submitted successfully.");
    // reset med_staff fields
    setMedName("");
    setMedIdNumber("");
    setFileInfo(null);
    setAgree(false);
    setSelectedCard(null);
    if (onBack) onBack();
  };

  const handleMciSubmit = (e) => {
    e.preventDefault();
    if (!isMciValid()) return;
    showSuccess("MCI proof submitted successfully.");
    setDoctorName("");
    setMciNumber("");
    setFileInfo(null);
    setAgree(false);
    setSelectedCard(null);
    if (onBack) onBack();
  };

  const handleDrugSubmit = (e) => {
    e.preventDefault();
    if (!isDrugFormValid()) return;
    showSuccess("Drug License submitted successfully.");
    setShopName("");
    setDrugNumber("");
    setFileInfo(null);
    setAgree(false);
    setSelectedCard(null);
    if (onBack) onBack();
  };

  const handleGstSubmit = (e) => {
    if (!isGstValid) return;
    showSuccess("GST Proof submitted successfully.");
    setGstNumber("");
    setAgree(false);
    if (onBack) onBack();
  };

  const handleVciSubmit = (e) => {
    e.preventDefault();
    if (!isVciValid()) return;
    showSuccess("VCI proof submitted successfully.");
    setDoctorNameVci("");
    setVciNumber("");
    setFileInfo(null);
    setAgree(false);
    setSelectedCard(null);
    if (onBack) onBack();
  };

  const handleDciSubmit = (e) => {
    e.preventDefault();
    if (!isDciValid()) return;
    showSuccess("DCI proof submitted successfully.");
    setDoctorNameDci("");
    setDciNumber("");
    setFileInfo(null);
    setAgree(false);
    setSelectedCard(null);
    if (onBack) onBack();
  };

  const resetShopForm = () => {
    setShopName("");
    setProofNumber("");
    setFileInfo(null);
    setAgree(false);
  };

  const handleFileChange = (e) => {
    const f = e.target.files && e.target.files[0];
    if (f) {
      setFileInfo({ name: f.name, size: f.size, type: f.type, file: f });
    }
  };

  const isShopFormValid = () => {
    return (
      shopName.trim().length > 0 &&
      proofNumber.trim().length > 0 &&
      fileInfo !== null &&
      agree === true
    );
  };

  const handleShopSubmit = (e) => {
    e.preventDefault();
    if (!isShopFormValid()) return;
    showSuccess("Shop & Establishment Proof submitted successfully.");
    resetShopForm();
    setSelectedCard(null);
    if (onBack) onBack();
  };

  if (selectedCard === "shop") {
    return (
      <div className="kyc-selected">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <button className="kyc-back" onClick={() => setSelectedCard(null)}>
            ← Back
          </button>
          <h1 className="kyc-heading" style={{ margin: 0 }}>
            Complete KYC
          </h1>
        </div>

        <p className="kyc-note" style={{ marginTop: 8 }}>
          For regulatory compliance, you are required to submit below proof of
          identity as a one time exercise. Please be assured this data will not
          be shared with any third party as per{" "}
          <a href="#" onClick={(e) => e.preventDefault()}>
            Privacy T&C
          </a>
          .
        </p>

        <div style={{ marginTop: 14 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>KYC Proof :</strong> Shop and Establishment Proof &nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedCard(null);
              }}
            >
              Change
            </a>
          </div>

          <form
            className="kyc-shop-form"
            onSubmit={handleShopSubmit}
            noValidate
          >
            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Business / Shop's Name*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                Make sure the name is same as mentioned on your shop &
                establishment certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={shopName}
                onChange={(e) => setShopName(e.target.value)}
                placeholder="Enter the shop's name mentioned in certificate"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Shop and Establishment Proof*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The number should be associated with above mentioned business
                name. Please enter the number in the same format as in the
                certificate.
                <div style={{ marginTop: 6 }}>
                  You can only buy selected products with shop & establishment
                  certificate proof.
                </div>
              </div>
              <input
                className="kyc-input"
                type="text"
                value={proofNumber}
                onChange={(e) => setProofNumber(e.target.value)}
                placeholder="eg. M2837283"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Upload Proof*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The document should contain above mentioned business name.
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".png,.jpg,.jpeg,.pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Choose a file ⬆
                </label>

                <span style={{ fontSize: 14, color: "#6b7280" }}>OR</span>

                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Take a photo 📷
                </label>

                <div
                  style={{
                    marginLeft: "auto",
                    minWidth: 200,
                    color: "#374151",
                    fontSize: 14,
                  }}
                >
                  {fileInfo ? (
                    <div>
                      <div style={{ fontWeight: 600 }}>{fileInfo.name}</div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        {(fileInfo.size / 1024).toFixed(1)} KB
                      </div>
                    </div>
                  ) : (
                    <div style={{ color: "#9ca3af" }}>No file selected</div>
                  )}
                </div>
              </div>

              {/* hidden controls activation helpers */}
              <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    fileInputRef.current && fileInputRef.current.click()
                  }
                >
                  Choose a file
                </button>

                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    cameraInputRef.current && cameraInputRef.current.click()
                  }
                >
                  Take a photo
                </button>
              </div>
            </div>

            <div style={{ marginTop: 8 }}>
              <a
                className="report-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                Report an issue
              </a>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 12,
              }}
            >
              <label className="terms" style={{ alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={() => setAgree((s) => !s)}
                />
                <span style={{ marginLeft: 6 }}>
                  I agree with Elumia{" "}
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    KYC terms and conditions
                  </a>
                </span>
              </label>
            </div>

            <div style={{ marginTop: 18 }}>
              <button
                type="submit"
                className="kyc-submit-btn"
                disabled={!isShopFormValid()}
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 6,
                  border: "none",
                  background: isShopFormValid() ? "#3b5bff" : "#9aa3b2",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: isShopFormValid() ? "pointer" : "not-allowed",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  if (selectedCard === "gst") {
    return (
      <div className="kyc-selected">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <button className="kyc-back" onClick={() => setSelectedCard(null)}>
            ← Back
          </button>
          <h1 className="kyc-heading" style={{ margin: 0 }}>
            Complete KYC
          </h1>
        </div>

        <p className="kyc-note" style={{ marginTop: 8 }}>
          For regulatory compliance, you are required to submit below proof of
          identity as a one time exercise. Please be assured this data will not
          be shared with any third party as per{" "}
          <a href="#" onClick={(e) => e.preventDefault()}>
            Privacy T&C
          </a>
          .
        </p>

        <div style={{ marginTop: 14 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>KYC Proof :</strong> GST Number &nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedCard(null);
              }}
            >
              Change
            </a>
          </div>

          <form className="kyc-gst-form" onSubmit={handleGstSubmit} noValidate>
            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                GST Number*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The number should be associated with above mentioned business
                name. You can only buy selected products with GST number.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={gstNumber}
                onChange={(e) => setGstNumber(e.target.value)}
                placeholder="eg. M2837283"
                aria-required="true"
              />
            </div>

            <div style={{ marginTop: 8 }}>
              <a
                className="report-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                Report an issue
              </a>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 12,
              }}
            >
              <label className="terms" style={{ alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={() => setAgree((s) => !s)}
                />
                <span style={{ marginLeft: 6 }}>
                  I agree with Elumia{" "}
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    KYC terms and conditions
                  </a>
                </span>
              </label>
            </div>

            <div style={{ marginTop: 18 }}>
              <button
                type="submit"
                className="kyc-submit-btn"
                disabled={!isGstValid}
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 6,
                  border: "none",
                  background: isGstValid ? "#3b5bff" : "#9aa3b2",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: isGstValid ? "pointer" : "not-allowed",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  if (selectedCard === "drug") {
    return (
      <div className="kyc-selected">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <button className="kyc-back" onClick={() => setSelectedCard(null)}>
            ← Back
          </button>
          <h1 className="kyc-heading" style={{ margin: 0 }}>
            Complete KYC
          </h1>
        </div>

        <p className="kyc-note" style={{ marginTop: 8 }}>
          For regulatory compliance, you are required to submit below proof of
          identity as a one time exercise. Please be assured this data will not
          be shared with any third party as per{" "}
          <a href="#" onClick={(e) => e.preventDefault()}>
            Privacy T&C
          </a>
          .
        </p>

        <div style={{ marginTop: 14 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>KYC Proof :</strong> Drug License &nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedCard(null);
              }}
            >
              Change
            </a>
          </div>

          <form
            className="kyc-shop-form"
            onSubmit={handleDrugSubmit}
            noValidate
          >
            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Business / Shop's Name*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                Make sure the name is same as mentioned on your Drug License
                certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={shopName}
                onChange={(e) => setShopName(e.target.value)}
                placeholder="Enter the shop's name mentioned in certificate"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Drug License*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The number should be associated with above mentioned business
                name. Please enter the number in the same format as in the
                certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={drugNumber}
                onChange={(e) => setDrugNumber(e.target.value)}
                placeholder="eg. M2837283"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Upload Proof*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The document should contain above mentioned business name.
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".png,.jpg,.jpeg,.pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Choose a file ⬆
                </label>

                <span style={{ fontSize: 14, color: "#6b7280" }}>OR</span>

                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Take a photo 📷
                </label>

                <div
                  style={{
                    marginLeft: "auto",
                    minWidth: 200,
                    color: "#374151",
                    fontSize: 14,
                  }}
                >
                  {fileInfo ? (
                    <div>
                      <div style={{ fontWeight: 600 }}>{fileInfo.name}</div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        {(fileInfo.size / 1024).toFixed(1)} KB
                      </div>
                    </div>
                  ) : (
                    <div style={{ color: "#9ca3af" }}>No file selected</div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    fileInputRef.current && fileInputRef.current.click()
                  }
                >
                  Choose a file
                </button>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    cameraInputRef.current && cameraInputRef.current.click()
                  }
                >
                  Take a photo
                </button>
              </div>
            </div>

            <div style={{ marginTop: 8 }}>
              <a
                className="report-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                Report an issue
              </a>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 12,
              }}
            >
              <label className="terms" style={{ alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={() => setAgree((s) => !s)}
                />
                <span style={{ marginLeft: 6 }}>
                  I agree with Elumia{" "}
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    KYC terms and conditions
                  </a>
                </span>
              </label>
            </div>

            <div style={{ marginTop: 18 }}>
              <button
                type="submit"
                className="kyc-submit-btn"
                disabled={!isDrugFormValid()}
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 6,
                  border: "none",
                  background: isDrugFormValid() ? "#3b5bff" : "#9aa3b2",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: isDrugFormValid() ? "pointer" : "not-allowed",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  if (selectedCard === "mci") {
    return (
      <div className="kyc-selected">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <button className="kyc-back" onClick={() => setSelectedCard(null)}>
            ← Back
          </button>
          <h1 className="kyc-heading" style={{ margin: 0 }}>
            Complete KYC
          </h1>
        </div>

        <p className="kyc-note" style={{ marginTop: 8 }}>
          For regulatory compliance, you are required to submit below proof of
          identity as a one time exercise. Please be assured this data will not
          be shared with any third party as per{" "}
          <a href="#" onClick={(e) => e.preventDefault()}>
            Privacy T&C
          </a>
          .
        </p>

        <div style={{ marginTop: 14 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>KYC Proof :</strong> Medical Council of UAE Registration
            (MCI) &nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedCard(null);
              }}
            >
              Change
            </a>
          </div>

          <form className="kyc-shop-form" onSubmit={handleMciSubmit} noValidate>
            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Doctor's Name*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                Make sure the name is same as mentioned on your registration
                certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={doctorName}
                onChange={(e) => setDoctorName(e.target.value)}
                placeholder="Enter the doctor's name as mentioned in certificate"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Medical Council of UAE Registration (MCI)*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The number should be associated with above mentioned doctor's
                name. Please enter the number in the same format as in the
                certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={mciNumber}
                onChange={(e) => setMciNumber(e.target.value)}
                placeholder="eg. M2837283"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Upload Proof*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The document should contain above mentioned doctor's name.
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".png,.jpg,.jpeg,.pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Choose a file ⬆
                </label>

                <span style={{ fontSize: 14, color: "#6b7280" }}>OR</span>

                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Take a photo 📷
                </label>

                <div
                  style={{
                    marginLeft: "auto",
                    minWidth: 200,
                    color: "#374151",
                    fontSize: 14,
                  }}
                >
                  {fileInfo ? (
                    <div>
                      <div style={{ fontWeight: 600 }}>{fileInfo.name}</div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        {(fileInfo.size / 1024).toFixed(1)} KB
                      </div>
                    </div>
                  ) : (
                    <div style={{ color: "#9ca3af" }}>No file selected</div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    fileInputRef.current && fileInputRef.current.click()
                  }
                >
                  Choose a file
                </button>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    cameraInputRef.current && cameraInputRef.current.click()
                  }
                >
                  Take a photo
                </button>
              </div>
            </div>

            <div style={{ marginTop: 8 }}>
              <a
                className="report-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                Report an issue
              </a>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 12,
              }}
            >
              <label className="terms" style={{ alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={() => setAgree((s) => !s)}
                />
                <span style={{ marginLeft: 6 }}>
                  I agree with Elumia{" "}
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    KYC terms and conditions
                  </a>
                </span>
              </label>
            </div>

            <div style={{ marginTop: 18 }}>
              <button
                type="submit"
                className="kyc-submit-btn"
                disabled={!isMciValid()}
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 6,
                  border: "none",
                  background: isMciValid() ? "#3b5bff" : "#9aa3b2",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: isMciValid() ? "pointer" : "not-allowed",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  if (selectedCard === "vci") {
    return (
      <div className="kyc-selected">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <button className="kyc-back" onClick={() => setSelectedCard(null)}>
            ← Back
          </button>
          <h1 className="kyc-heading" style={{ margin: 0 }}>
            Complete KYC
          </h1>
        </div>

        <p className="kyc-note" style={{ marginTop: 8 }}>
          For regulatory compliance, you are required to submit below proof of
          identity as a one time exercise. Please be assured this data will not
          be shared with any third party as per{" "}
          <a href="#" onClick={(e) => e.preventDefault()}>
            Privacy T&C
          </a>
          .
        </p>

        <div style={{ marginTop: 14 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>KYC Proof :</strong> Veterinary Council of UAE Registration
            (VCI) &nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedCard(null);
              }}
            >
              Change
            </a>
          </div>

          <form className="kyc-shop-form" onSubmit={handleVciSubmit} noValidate>
            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Doctor's Name*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                Make sure the name is same as mentioned on your registration
                certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={doctorNameVci}
                onChange={(e) => setDoctorNameVci(e.target.value)}
                placeholder="Enter the doctor's name as mentioned in certificate"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Veterinary Council of UAE Registration (VCI)*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The number should be associated with above mentioned doctor's
                name. Please enter the number in the same format as in the
                certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={vciNumber}
                onChange={(e) => setVciNumber(e.target.value)}
                placeholder="eg. M2837283"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Upload Proof*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The document should contain above mentioned doctor's name.
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".png,.jpg,.jpeg,.pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Choose a file ⬆
                </label>

                <span style={{ fontSize: 14, color: "#6b7280" }}>OR</span>

                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Take a photo 📷
                </label>

                <div
                  style={{
                    marginLeft: "auto",
                    minWidth: 200,
                    color: "#374151",
                    fontSize: 14,
                  }}
                >
                  {fileInfo ? (
                    <div>
                      <div style={{ fontWeight: 600 }}>{fileInfo.name}</div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        {(fileInfo.size / 1024).toFixed(1)} KB
                      </div>
                    </div>
                  ) : (
                    <div style={{ color: "#9ca3af" }}>No file selected</div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    fileInputRef.current && fileInputRef.current.click()
                  }
                >
                  Choose a file
                </button>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    cameraInputRef.current && cameraInputRef.current.click()
                  }
                >
                  Take a photo
                </button>
              </div>
            </div>

            <div style={{ marginTop: 8 }}>
              <a
                className="report-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                Report an issue
              </a>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 12,
              }}
            >
              <label className="terms" style={{ alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={() => setAgree((s) => !s)}
                />
                <span style={{ marginLeft: 6 }}>
                  I agree with Elumia{" "}
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    KYC terms and conditions
                  </a>
                </span>
              </label>
            </div>

            <div style={{ marginTop: 18 }}>
              <button
                type="submit"
                className="kyc-submit-btn"
                disabled={!isVciValid()}
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 6,
                  border: "none",
                  background: isVciValid() ? "#3b5bff" : "#9aa3b2",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: isVciValid() ? "pointer" : "not-allowed",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  if (selectedCard === "dci") {
    return (
      <div className="kyc-selected">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <button className="kyc-back" onClick={() => setSelectedCard(null)}>
            ← Back
          </button>
          <h1 className="kyc-heading" style={{ margin: 0 }}>
            Complete KYC
          </h1>
        </div>

        <p className="kyc-note" style={{ marginTop: 8 }}>
          For regulatory compliance, you are required to submit below proof of
          identity as a one time exercise. Please be assured this data will not
          be shared with any third party as per{" "}
          <a href="#" onClick={(e) => e.preventDefault()}>
            Privacy T&C
          </a>
          .
        </p>

        <div style={{ marginTop: 14 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>KYC Proof :</strong> Dental Council of UAE Registration
            (DCI) &nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedCard(null);
              }}
            >
              Change
            </a>
          </div>

          <form className="kyc-shop-form" onSubmit={handleDciSubmit} noValidate>
            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Doctor's Name*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                Make sure the name is same as mentioned on your registration
                certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={doctorNameDci}
                onChange={(e) => setDoctorNameDci(e.target.value)}
                placeholder="Enter the doctor's name as mentioned in certificate"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Dental Council of UAE Registration (DCI)*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The number should be associated with above mentioned doctor's
                name. Please enter the number in the same format as in the
                certificate.
              </div>
              <input
                className="kyc-input"
                type="text"
                value={dciNumber}
                onChange={(e) => setDciNumber(e.target.value)}
                placeholder="eg. M2837283"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Upload Proof*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The document should contain above mentioned doctor's name.
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".png,.jpg,.jpeg,.pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Choose a file ⬆
                </label>

                <span style={{ fontSize: 14, color: "#6b7280" }}>OR</span>

                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Take a photo 📷
                </label>

                <div
                  style={{
                    marginLeft: "auto",
                    minWidth: 200,
                    color: "#374151",
                    fontSize: 14,
                  }}
                >
                  {fileInfo ? (
                    <div>
                      <div style={{ fontWeight: 600 }}>{fileInfo.name}</div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        {(fileInfo.size / 1024).toFixed(1)} KB
                      </div>
                    </div>
                  ) : (
                    <div style={{ color: "#9ca3af" }}>No file selected</div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    fileInputRef.current && fileInputRef.current.click()
                  }
                >
                  Choose a file
                </button>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    cameraInputRef.current && cameraInputRef.current.click()
                  }
                >
                  Take a photo
                </button>
              </div>
            </div>

            <div style={{ marginTop: 8 }}>
              <a
                className="report-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                Report an issue
              </a>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 12,
              }}
            >
              <label className="terms" style={{ alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={() => setAgree((s) => !s)}
                />
                <span style={{ marginLeft: 6 }}>
                  I agree with Elumia{" "}
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    KYC terms and conditions
                  </a>
                </span>
              </label>
            </div>

            <div style={{ marginTop: 18 }}>
              <button
                type="submit"
                className="kyc-submit-btn"
                disabled={!isDciValid()}
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 6,
                  border: "none",
                  background: isDciValid() ? "#3b5bff" : "#9aa3b2",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: isDciValid() ? "pointer" : "not-allowed",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  if (selectedCard === "med_staff") {
    return (
      <div className="kyc-selected">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 8,
          }}
        >
          <button className="kyc-back" onClick={() => setSelectedCard(null)}>
            ← Back
          </button>
          <h1 className="kyc-heading" style={{ margin: 0 }}>
            Complete KYC
          </h1>
        </div>

        <p className="kyc-note" style={{ marginTop: 8 }}>
          For regulatory compliance, you are required to submit below proof of
          identity as a one time exercise. Please be assured this data will not
          be shared with any third party as per{" "}
          <a href="#" onClick={(e) => e.preventDefault()}>
            Privacy T&C
          </a>
          .
        </p>

        <div style={{ marginTop: 14 }}>
          <div style={{ marginBottom: 8 }}>
            <strong>KYC Proof :</strong> Medical Student/Employee ID &nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedCard(null);
              }}
            >
              Change
            </a>
          </div>

          <form
            className="kyc-shop-form"
            onSubmit={handleMedStaffSubmit}
            noValidate
          >
            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Enter Your Name*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                Enter your name mentioned in ID
              </div>
              <input
                className="kyc-input"
                type="text"
                value={medName}
                onChange={(e) => setMedName(e.target.value)}
                placeholder="Enter your name mentioned in ID"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                ID Number*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                Please enter student/employee ID number
              </div>
              <input
                className="kyc-input"
                type="text"
                value={medIdNumber}
                onChange={(e) => setMedIdNumber(e.target.value)}
                placeholder="eg. M2837283"
                aria-required="true"
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <label
                style={{ display: "block", fontWeight: 700, marginBottom: 6 }}
              >
                Upload Proof*
              </label>
              <div style={{ color: "#8b95a6", marginBottom: 8, fontSize: 13 }}>
                The document should contain above mentioned name.
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 12,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".png,.jpg,.jpeg,.pdf"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Choose a file ⬆
                </label>

                <span style={{ fontSize: 14, color: "#6b7280" }}>OR</span>

                <label className="kyc-file-btn" style={{ cursor: "pointer" }}>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                  />
                  Take a photo 📷
                </label>

                <div
                  style={{
                    marginLeft: "auto",
                    minWidth: 200,
                    color: "#374151",
                    fontSize: 14,
                  }}
                >
                  {fileInfo ? (
                    <div>
                      <div style={{ fontWeight: 600 }}>{fileInfo.name}</div>
                      <div style={{ fontSize: 12, color: "#6b7280" }}>
                        {(fileInfo.size / 1024).toFixed(1)} KB
                      </div>
                    </div>
                  ) : (
                    <div style={{ color: "#9ca3af" }}>No file selected</div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    fileInputRef.current && fileInputRef.current.click()
                  }
                >
                  Choose a file
                </button>
                <button
                  type="button"
                  className="btn-outline"
                  onClick={() =>
                    cameraInputRef.current && cameraInputRef.current.click()
                  }
                >
                  Take a photo
                </button>
              </div>
            </div>

            <div style={{ marginTop: 8 }}>
              <a
                className="report-link"
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                Report an issue
              </a>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginTop: 12,
              }}
            >
              <label className="terms" style={{ alignItems: "center" }}>
                <input
                  type="checkbox"
                  checked={agree}
                  onChange={() => setAgree((s) => !s)}
                />
                <span style={{ marginLeft: 6 }}>
                  I agree with Elumia{" "}
                  <a href="#" onClick={(e) => e.preventDefault()}>
                    KYC terms and conditions
                  </a>
                </span>
              </label>
            </div>

            <div style={{ marginTop: 18 }}>
              <button
                type="submit"
                className="kyc-submit-btn"
                disabled={!isMedStaffValid()}
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 6,
                  border: "none",
                  background: isMedStaffValid() ? "#3b5bff" : "#9aa3b2",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: isMedStaffValid() ? "pointer" : "not-allowed",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="kyc-page">
      <h1 className="kyc-heading">Complete KYC</h1>

      <p className="kyc-note">
        For regulatory compliance, you are required to submit below proof of
        identity as a one time exercise. Please be assured this data will not be
        shared with any third party as per{" "}
        <a href="#" onClick={(e) => e.preventDefault()}>
          Privacy T&C
        </a>
        .
      </p>

      <h2 className="upload-title">Upload Any KYC Proof</h2>

      <div className="kyc-grid">
        {cards.map((c) => (
          <button
            key={c.id}
            className="kyc-card"
            onClick={() => setSelectedCard(c.id)}
            type="button"
          >
            <div className="kyc-card-left">
              <span className="radio-circle">
                <span className="radio-dot" />
              </span>
            </div>

            <div className="kyc-card-body">
              <div className="kyc-card-title">{c.title}</div>
              {c.subtitle && <div className="kyc-card-sub">{c.subtitle}</div>}
            </div>
          </button>
        ))}
      </div>
      {selectedCard === "patient" && (
        <div className="kyc-selected">
          <div style={{ marginTop: 14 }}>
            <div
              style={{ color: "#f97316", fontWeight: 700, marginBottom: 10 }}
            >
              As per govt regulations, we can only sell to medical practitioners
              or suppliers with any valid DCI, MCI, VCI, GST, DL, Shop &amp;
              Est.
            </div>
          </div>
        </div>
      )}
      <div className="kyc-footer">
        <a className="report-link" href="#" onClick={(e) => e.preventDefault()}>
          Report an issue
        </a>
        <label className="terms">
          <input
            type="checkbox"
            checked={agree}
            onChange={() => setAgree((s) => !s)}
          />
          <span>
            I agree with Elumia{" "}
            <a href="#" onClick={(e) => e.preventDefault()}>
              KYC terms and conditions
            </a>
          </span>
        </label>
      </div>
    </div>
  );
}
